exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "div.past-comments {\n  display: flex;\n  align-items: center;\n  font-style: italic; }\n  div.past-comments hr {\n    padding: 0;\n    width: 17%; }\n  div.past-comments a {\n    font-size: 12px;\n    padding: 0px;\n    text-align: center;\n    color: rgba(0, 0, 0, 0.5);\n    cursor: pointer; }\n", ""]);

